import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

declare function sg_beacon(action: string, token: string, product?: string);

@Injectable({
  providedIn: "root"
})
export class UEMSurveyService {

  private surveyToken = 'NjY5MDI4LThhODUxZmNiNmRlMTQ2ZDc0ZTM5ZmEzZTcyMWVlOGE4M2VjNDVmMzJjOGZlMTdhNjcz';
  private routesToAvoid = ['/pdf/'];

  constructor(private location: Location, private router: Router) {
    //this.onRouteChange();
   }

   init() {
    if(sg_beacon === null) {
      throw new Error('Alchemer beacon not loaded correctly');
    }
    setTimeout( () => {
      sg_beacon('init', this.surveyToken)
      sg_beacon('data', 'prod', 'pulse');
    }, 0);
   }

   onRouteChange() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      const pathContainsInvalidRoute = this.routesToAvoid.some(routeToAvoid =>
        this.location.path().includes(routeToAvoid)
        );
        if (pathContainsInvalidRoute) { 
          return; 
        }

        try { 
          this.init(); 
        } catch (e) { 
          console.warn(e); 
        }
      });
   }
}
